import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';
import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class DailyAnalyticLogsService extends RestfulService<Models.DailyAnalyticLog> {

  constructor(public restService: RestService) {
    super(Models.DailyAnalyticLog);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('daily-analytic-log-by-timestamps');
  }
}
